import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    loanRequestId: string;
    userId: string;
};

export const schemaLoanRequestResolver_IsAssignedToUser = z.boolean();

export type SchemaLoanRequestResolver_IsAssignedToUser = z.infer<typeof schemaLoanRequestResolver_IsAssignedToUser>;

export type LoanRequestResolver_IsAssignedToUser = Resolver<Arguments, SchemaLoanRequestResolver_IsAssignedToUser>;
